var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.elements, function (element) {
      return _c("child-dynamic-element", {
        key: element.identifier,
        attrs: {
          element: Object.assign(
            {},
            { conditionalValue: _vm.notEmptyValue },
            element
          ),
          formName: _vm.formName,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }